import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import React from "react";
import { Col } from "react-bootstrap";
var RightAccordiancontent = function (props) {
    var device = DeviceContext();
    return (React.createElement(React.Fragment, null,
        React.createElement(Col, { lg: 12, className: "right-content-box mgt-15 ".concat(props.parentClassName) },
            React.createElement("div", { className: "left-section" },
                React.createElement("span", { className: device && device.isDesktop
                        ? "DMSansNormal_20_400 d-flex justify-content-left align-items-center txt_blackOne1 "
                        : "DMSanM_14_500 d-flex justify-content-left align-items-center txt_blackOne1 " }, props.heading),
                React.createElement("span", { className: "DMSanN_16_400 d-flex justify-content-left align-items-center txt_primaryGrey subhedding-acc line-30" }, props.subHeading)),
            React.createElement("div", { className: "right-section hand_cursor" }, props.bothContent ? (React.createElement(React.Fragment, null,
                props.rightContent,
                React.createElement("i", { className: "edel-icon-arrow-right-big", onClick: function () {
                        props.onClick && (props === null || props === void 0 ? void 0 : props.onClick());
                    } }))) : props.rightIcon ? (React.createElement("i", { className: "edel-icon-arrow-right-big", onClick: function () {
                    props.onClick && (props === null || props === void 0 ? void 0 : props.onClick());
                } })) : (React.createElement(React.Fragment, null, props.rightContent))))));
};
export default RightAccordiancontent;
